/**
 * Unfortunately i could not found a way to ignore TS linting cross-lines.
 * The below code is the code snippet by GA to inject the classic GA sdk.
 */
export const injectGaScript = (): void => {
  (function (i, s, o, g, r, a, m) {
    // @ts-ignore
    i['GoogleAnalyticsObject'] = r;
    // @ts-ignore
    (i[`${r}`] =
      // @ts-ignore
      i[`${r}`] ||
      function () {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        (i[`${r}`].q = i[`${r}`].q || []).push(arguments);
      }),
      // @ts-ignore
      (i[`${r}`].l = 1 * new Date());
    // @ts-ignore
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    // @ts-ignore
    a.async = 1;
    // @ts-ignore
    a.src = g;
    // @ts-ignore
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
};
